import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { NotificationDetails } from '../modal';

export default function reducer(state: NotificationDetails = new NotificationDetails(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.NOTIFICATION_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.NOTIFICATION_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.NOTIFICATION_DETAILS_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
